import React from 'react';
import { FiX, FiInfo, FiCheckCircle, FiAlertTriangle, FiAlertCircle } from 'react-icons/fi';

const icons = {
  info: FiInfo,
  success: FiCheckCircle,
  warning: FiAlertTriangle,
  error: FiAlertCircle,
};

const tones = {
  info: 'from-sky-500 to-blue-500',
  success: 'from-emerald-500 to-green-500',
  warning: 'from-amber-500 to-orange-500',
  error: 'from-rose-500 to-red-600',
};

const AlertStack = ({ alerts, onClose }) => {
  return (
    <div className="fixed top-4 right-4 z-50 space-y-3 w-80 max-w-[90vw]">
      {alerts.map((a) => {
        const Icon = icons[a.type] || FiInfo;
        return (
          <div
            key={a.id}
            className="animate-pop shadow-xl rounded-xl overflow-hidden bg-white dark:bg-gray-900 border border-white/40 dark:border-gray-700 backdrop-blur-md"
          >
            <div className={`h-1 w-full bg-gradient-to-r ${tones[a.type]}`} />
            <div className="flex items-start px-4 py-3 space-x-3">
              <div className="p-2 rounded-lg bg-gray-100 dark:bg-gray-800 text-primary-600 dark:text-primary-200">
                <Icon />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {a.title || a.type?.toUpperCase()}
                </p>
                {a.message && (
                  <p className="text-xs text-gray-600 dark:text-gray-300 mt-0.5">{a.message}</p>
                )}
              </div>
              <button
                onClick={() => onClose(a.id)}
                className="text-gray-400 hover:text-gray-700 dark:hover:text-gray-100"
                aria-label="Close"
              >
                <FiX />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlertStack;


